/* eslint-disable lingui/no-unlocalized-strings -- Approved First Round plan copy. */
import { type FirstRoundPlanCard, formatPlanPrice } from "@/client/services/pricing/first-round";

type Classes = { offer: string; price: string; was: string };

/**
 * A plan's price, with the offer when there is one: "INTRODUCTORY OFFER", then ~~$99~~ $69. A
 * checked code takes the offer's place: "SAVE20 · 20% OFF", then ~~$69~~ $55.20 (or "FREE WITH
 * YOUR CODE", ~~$69~~ $0). Cards without either keep an empty offer line so prices sit level.
 */
export const PlanPrice = ({
  card,
  classes,
  code,
}: {
  card: Pick<FirstRoundPlanCard, "price" | "currency" | "compareAtPrice" | "offerLabel">;
  classes: Classes;
  /** What a checked code does to this card (see codeOffer). */
  code?: { label: string; price: number } | null;
}) => {
  const was = code ? card.price : card.compareAtPrice;
  const label = code ? code.label : card.offerLabel;
  const price = code ? code.price : card.price;
  return (
    <>
      <p className={classes.offer} aria-hidden={was === null || undefined}>
        {was !== null && label ? label : " "}
      </p>
      <p className={classes.price}>
        {was !== null && (
          <>
            <s className={classes.was}>
              <span className="sr-only">Usually </span>
              {formatPlanPrice(was, card.currency)}
            </s>{" "}
            <span className="sr-only">now </span>
          </>
        )}
        {formatPlanPrice(price, card.currency)}
      </p>
    </>
  );
};

/** The empty offer line for cards with no price from the database (Enterprise). */
export const PlanOfferSpacer = ({ className }: { className: string }) => (
  <p className={className} aria-hidden="true">
    {" "}
  </p>
);
